import React from 'react'

export default function RulesProcedures() {
  return (
    <div>RulesProcedures</div>
  )
}
